import { Component } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { PIN_MINIMUM_FOUR_MAXIMUM_FOUR_CHARACTERS_ONLY_NUMBERS, pinMatchingValidator } from '@shared/feature/forms';
import { InputDisplay, InputFieldType } from '@shared/ui/inputs';
import { EditProfileService } from '../../services/edit-profile.service';

@Component({
    selector: 'sh-shared-layout-change-pin-dialog',
    templateUrl: './change-pin-dialog.component.html',
    styleUrls: ['./change-pin-dialog.component.css'],
    standalone: false
})
export class ChangePinDialogComponent {
  pinForm: FormGroup;
  inputType = InputFieldType.Password;
  inputFieldDisplay = InputDisplay.Inline;

  officerUid?: string;

  constructor(public service: EditProfileService) {
    this.pinForm = new FormGroup(
      {
        pin: new FormControl('', [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          Validators.pattern(PIN_MINIMUM_FOUR_MAXIMUM_FOUR_CHARACTERS_ONLY_NUMBERS),
        ]),
        confirmPin: new FormControl('', [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          Validators.pattern(PIN_MINIMUM_FOUR_MAXIMUM_FOUR_CHARACTERS_ONLY_NUMBERS),
        ]),
      },
      { validators: pinMatchingValidator() }
    );
  }

  onChangeClick(): void {
    this.service.changeLoggedInOfficerPin(this.pinForm.value.pin, this.officerUid);
  }
}
